import React, { useState } from 'react';
import { Button, Card, Col, ListGroup, Row } from 'react-bootstrap-5';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import NewTaskModal from './tasks/new_task_modal';
import EmptyState from '../empty_state';
import Task from './tasks/task';
import EditTaskModal from './tasks/edit_task_modal';
import { addActivity, removeActivity, updateActivity } from 'bundles/connect/components/store/actions/activities';
import { PROPERTY_MODEL } from '../../constants';
import type { Activity } from 'bundles/connect/types';

type Props = {
  activities: Activity[];
  addActivity: (activity: Activity) => void;
  connectPropertyId: number;
  removeActivity: (id: number, type: string) => Promise<void>;
  updateActivity: (activity: Activity) => Promise<void>;
}

function Tasks({ connectPropertyId, activities, addActivity, removeActivity, updateActivity }: Props) {
  const [showNewTaskModal, setShowNewTaskModal] = useState(false);
  const [taskForEdit, setTaskForEdit] = useState<Activity | null>(null);
  const tasks = activities.filter(activity => activity.isTask && !activity.completedAt);

  return (
    <div>
      <Card className="shadow">
        <Card.Header>
          <Row className="align-items-center">
            <Col>
              <h6 className="fw-semibold mb-0">Tasks</h6>
            </Col>
            <Col xs="auto">
              <Button className="btn-as-text" variant="text-primary" onClick={() => setShowNewTaskModal(true)}>
                <FontAwesomeIcon icon={faCirclePlus} /> New Task
              </Button>
            </Col>
          </Row>
        </Card.Header>
        {tasks.length === 0 && (
          <Card.Body>
            <EmptyState
              icon={faCalendar}
              text="There are no tasks in the queue."
            />
          </Card.Body>
        )}
        {tasks.length > 0 && (
          <ListGroup variant="flush">
            {tasks.map(task => (
              <Task
                key={task.id}
                showConnectionBadges={false}
                task={task}
                onDelete={() => removeActivity(task.id, 'Task')}
                onEdit={setTaskForEdit}
                onUpdate={updateActivity}
              />
            ))}
          </ListGroup>
        )}
      </Card>
      <NewTaskModal
        autoAddConnectedRecords={[
          {
            connectedRecordType: PROPERTY_MODEL,
            connectedRecordId: connectPropertyId,
            label: '',
            link: ''
          }
        ]}
        show={showNewTaskModal}
        onAdd={addActivity}
        onHide={() => setShowNewTaskModal(false)}
      />
      <EditTaskModal
        existingActivity={taskForEdit}
        onHide={() => setTaskForEdit(null)}
        onUpdate={updateActivity}
      />
    </div>

  );
}

const mapStateToProps = ({ activities }) => ({ activities });
export default connect(mapStateToProps, {
  addActivity,
  removeActivity,
  updateActivity,
})(Tasks);
